// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a776a28d","65":"07d41c09","188":"de65db82","204":"421360c2","230":"d052399f","482":"1b495df3","490":"1b71c9e6","513":"a8c54818","631":"b2995961","694":"010a19ca","743":"ccb48e8e","760":"d1c6d431","787":"55493f23","924":"9f0a9dde"}[chunkId] + ".chunk.js";
};